import { ReactNode } from 'react';
import { Auth0Provider as Auth0ProviderBase } from '@auth0/auth0-react';

interface Auth0ProviderProps {
    children: ReactNode;
}

export const Auth0Provider = ({ children }: Auth0ProviderProps) => {
    const domain = import.meta.env.VITE_AUTH0_DOMAIN;
    const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

    if (!domain || !clientId || !audience) {
        return <div className="p-4 text-red-600">Error: Auth0 environment variables are not configured.</div>;
    }

    return (
        <Auth0ProviderBase
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: audience,
                scope: 'openid profile email'
            }}
            cacheLocation="localstorage"
            useRefreshTokens={true}
        >
            {children}
        </Auth0ProviderBase>
    );
}; 